// template lis
import {
  TEMPLATE_SUCCESS,
  DEFAULT_LOGO_SUCCESS,
  COMMON_REQUEST,
  COMMON_REQUEST_FAIL,
  STRIPE_PAYMENT_SUCCESS,
  RENDERS_PLAN_SUCCESS,
  CURRENT_PLAN_SUCCESS,
  SUBSCRIPTION_CANCELL_SUCCESS,
  NOTIFICATION_SUCCESS,
  OPTION_REQUEST,
  PROJECT_OPTION_SUCCESS,
  GLOBAL_COLOR_SUCCESS,
  USER_STRIPE_DATA_SUCCESS,
  PLAN_SELECT_REQUEST,
  PLAN_SELECT_SUCCESS,
  ADD_NOTIFICATION,
  PAGE_SELECT_REQUEST,
  PAGE_SELECT_SUCCESS,
  USER_FETCH_SUCCESS,
  FIRST_TIME_RENDER_AFTER_PLAN_SUCCESS,
  USER_LOGOUT,
} from "./types";
import { getRequest, postRequest } from "../../services/axios";
export const allTemplatesList = () => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await getRequest(`/template`);
    const { data } = response?.data;
    dispatch({
      type: TEMPLATE_SUCCESS,
      payload: {
        data,
      },
    });
    return response?.data;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const stripePayment =
  (token, product, coupanName) => async (dispatch) => {
    console.log(
      "1 API Call stripePayment Request token, product, coupanName =  ",
      token,
      product,
      coupanName,
    );
    try {
      dispatch({ type: COMMON_REQUEST });
      let body = {
        token,
        product,
        coupanName,
      };
      const response = await postRequest(`/user/makeSubscription`, body);
      console.log("2 API Call stripePayment response=", response);

      if (response?.status === 200) {
        dispatch({
          type: STRIPE_PAYMENT_SUCCESS,
          payload: {
            data: response?.data,
          },
        });
        dispatch(getCurrentPlan());
      } else {
        dispatch({
          type: COMMON_REQUEST_FAIL,
          payload: {
            error: response.error,
          },
        });
      }
      return response;
    } catch (error) {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };
export const applyCoupen = (coupanName) => async (dispatch) => {
  console.log("1 API Call applyCoupen Request coupanName = ", coupanName);
  try {
    const response = await postRequest("/project/checkCoupanCodes", {
      coupanName,
    });
    return response;
  } catch (error) {
    return error;
  }
};
export const getRendersPlan = (user) => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest("/project/getPlans");

    if (response?.status === 200) {
      dispatch({
        type: RENDERS_PLAN_SUCCESS,
        payload: response?.data?.plans,
      });
    } else {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error: response.error,
        },
      });
    }
    return response;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// create checkout session
export const createCheckoutSession = (planId) => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest("/user/checkout", { planId });

    if (response?.success) {
      return response.data;
    }
    return response;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// create embedded checkout session (returns clientSecret for EmbeddedCheckout)
export const createEmbeddedCheckoutSession = (planId) => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest("/user/checkout", { planId });

    if (response?.data?.success) {
      return response.data; // { success, session, clientSecret }
    }
    throw new Error("Failed to create checkout session");
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
    throw error;
  }
};

export const getCurrentPlan = (user) => async (dispatch) => {
  // console.log("API getCurrentPlan Request");
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest("/user/getUserPlan");
    // console.log("API getCurrentPlan response => ", response);
    if (response?.status === 200 && response.data.success) {
      dispatch({
        type: CURRENT_PLAN_SUCCESS,
        payload: response?.data,
      });
    } else {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error: response.error,
        },
      });
    }
    return response;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const CancellSubscription = (order_id) => async (dispatch) => {
  // console.log("API CancellSubscription Request order_id = ", order_id);
  try {
    dispatch({ type: COMMON_REQUEST });
    const response = await postRequest(`/user/cancelSubscription`, {
      order_id,
    });
    // console.log("API CancellSubscription response => ", response);
    if (response?.status === 200) {
      dispatch({
        type: SUBSCRIPTION_CANCELL_SUCCESS,
        payload: {
          data: response?.data,
        },
      });
    } else {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error: response.error,
        },
      });
    }
    return response;
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// Skip Model
export const skipUserModel =
  ({ dashModalStatus, layoutModalstatus }) =>
  async () => {
    try {
      const response = await postRequest("/user/skipModal", {
        dashModalStatus,
        layoutModalstatus,
      });
      return response;
    } catch (error) {
      return error;
    }
  };

//GLOBAL_COLOR_SUCCESS
export const setGlobalColorInReudx = (colorValue) => async (dispatch) => {
  try {
    dispatch({ type: COMMON_REQUEST });
    dispatch({
      type: GLOBAL_COLOR_SUCCESS,
      payload: colorValue,
    });
  } catch (error) {
    return error;
  }
};

//notification
export const getNotification = () => async (dispatch) => {
  // pagination work remaining ******
  try {
    const response = await postRequest("/user/getNotification", {
      limit: 20,
      page_no: 1,
    });
    // console.log(response.data);
    dispatch({ type: COMMON_REQUEST });
    if (response.data.success) {
      dispatch({
        type: NOTIFICATION_SUCCESS,
        payload: response.data,
      });
      return response.data.notifications;
    }
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const addNotification = (notification) => ({
  type: ADD_NOTIFICATION,
  payload: notification,
});

export const updateNotification = () => async (dispatch) => {
  try {
    const response = await postRequest("/user/updateNotification");
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const addNotifications =
  ({ project_id, render_id, message, status, user_id }) =>
  async (dispatch) => {
    try {
      const response = await postRequest("/user/addNotification", {
        project_id,
        render_id,
        message,
        status,
        user_id,
      });
      dispatch({ type: COMMON_REQUEST });
      if (response.data.success) {
        const res = await postRequest("/user/getNotification");
        dispatch({
          type: NOTIFICATION_SUCCESS,
          payload: res.data.notifications,
        });
      }
    } catch (error) {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const deleteNotifications =
  ({ notification_id }) =>
  async (dispatch) => {
    try {
      const response = await postRequest("/user/deleteNotification", {
        notification_id,
      });
      if (response.data.success) {
        const res = await postRequest("/user/getNotification", {
          limit: 20,
          page_no: 1,
        });
        dispatch({
          type: NOTIFICATION_SUCCESS,
          payload: {
            notifications: res.data.notifications,
            notificationsWithReadStatus: res.data.notificationsWithReadStatus,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: COMMON_REQUEST_FAIL,
        payload: {
          error:
            error.response && error.response.data.message
              ? error.response.data.message
              : error.message,
        },
      });
    }
  };

export const addSurvey = (answer, answerTwo) => async (dispatch) => {
  try {
    await postRequest("/user/addSurvey", { answer, answerTwo });
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const hasUserFilledSurvey = async () => {
  try {
    const response = await getRequest("/user/userFilledSurvey");
    if (response.data.success) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return error;
  }
};

export const userSeenTutorial = (status) => async (dispatch) => {
  try {
    await postRequest("/user/updateTutorialStatus", { status });
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

// // function to fetch all data for helpPage
// export const getHelpPageData = () => async (dispatch) => {
//   try {
//   } catch (error) {
//     dispatch({
//       type: COMMON_REQUEST_FAIL,
//       payload: {
//         error:
//           error.response && error.response.data.message
//             ? error.response.data.message
//             : error.message,
//       },
//     });
//   }
// };

// // get stripe data
// // get stripe data
// export const getUserStripeData = () => async (dispatch) => {
//   try {
//     // Set loading state
//     dispatch({ type: COMMON_REQUEST });

//     const response = await getRequest("/user/getUserStripeDetails");

//     if (response.data.success) {
//       dispatch({
//         type: USER_STRIPE_DATA_SUCCESS,
//         payload: response.data.invoices,
//       });
//     } else {
//       dispatch({
//         type: COMMON_REQUEST_FAIL,
//         payload: {
//           error: response.data.message || 'Failed to fetch stripe data'
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: COMMON_REQUEST_FAIL,
//       payload: {
//         error:
//           error.response && error.response.data.message
//             ? error.response.data.message
//             : error.message,
//       },
//     });
//   }
// };

export const PlanHandler = (selectedPlan) => (dispatch) => {
  // console.log(' ACtion API  selectedPlan = ',selectedPlan);
  try {
    dispatch({ type: PLAN_SELECT_REQUEST });
    dispatch({
      type: PLAN_SELECT_SUCCESS,
      payload: selectedPlan,
    });
  } catch (error) {
    return error;
  }
};

// Page Select For Route => Dashboard/Project/Render/More-Info/All Plan
export const selectedPageOption =
  (isPageOptionSelected, _id, isCard) => (dispatch) => {
    try {
      dispatch({ type: PAGE_SELECT_REQUEST });
      dispatch({
        type: PAGE_SELECT_SUCCESS,
        payload: { isPageOptionSelected, _id, isCard },
      });
    } catch (error) {
      return error;
    }
  };

export const getUserAllInformation = () => async (dispatch) => {
  try {
    const userData = await getRequest("/user/getUserInfo");
    if (userData.data.success) {
      dispatch({
        type: USER_FETCH_SUCCESS,
        payload: userData.data.user,
      });
    }
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const updateUserCardInfo = () => async (dispatch) => {
  try {
    await getRequest("/user/updateUserInfo");
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const markRenderDone = () => async (dispatch) => {
  try {
    await postRequest("/user/markRenderDone");
    dispatch({
      type: FIRST_TIME_RENDER_AFTER_PLAN_SUCCESS,
      payload: true,
    });
  } catch (error) {
    dispatch({
      type: COMMON_REQUEST_FAIL,
      payload: {
        error:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      },
    });
  }
};

export const handleSessionExpired = () => (dispatch) => {
  dispatch({ type: USER_LOGOUT });
};
